<script setup lang="ts">
import { useSpeakerDetail } from '../lib/useSpeakerDetail';
import SpeakerDetailHeader from './SpeakerDetailHeader.vue';
import SpeakerDetailHero from './SpeakerDetailHero.vue';
import SpeakerDetailBio from './SpeakerDetailBio.vue';
import SpeakerDetailEvents from './SpeakerDetailEvents.vue';
import { useSpeakerDetailSeo } from '../lib/seo';

const { data, status, error } = await useSpeakerDetail();

useSpeakerDetailSeo(data);

if (error.value) {
  throw createError({
    status: 404,
    message: 'Спикер не найден',
    fatal: true,
  });
}
</script>

<template>
  <div :class="$style.page">
    <template v-if="data && status === 'success'">
      <SpeakerDetailHeader />
      <div :class="$style.inner">
        <div :class="$style.content">
          <SpeakerDetailHero
            :name="data.name"
            :position="data.position"
            :company="data.company?.name"
            :photo-url="data.photo?.file_url ?? null"
          />
          <SpeakerDetailBio :description="data.description" />
        </div>
        <SpeakerDetailEvents />
      </div>
    </template>

    <div v-else-if="status === 'pending'" :class="$style.loader">
      <Loader />
    </div>

    <div v-else-if="status === 'error'" :class="$style.error">
      <p>Не удалось загрузить информацию о спикере</p>
    </div>
  </div>
</template>

<style module lang="scss">
.page {
  background-color: var(--color-white);
  min-height: calc(100vh - 64px);
  padding-bottom: var(--space-6x);
}

.inner {
  padding: 0 110px;
}

.content {
  display: flex;
  flex-direction: column;
  padding-top: var(--space-5x);
  padding-bottom: var(--space-5x);
  gap: var(--space-5x);
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 64px);
}

.error {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 64px);
  @include text_body1;
  color: var(--color-gray-text);
}

@media (max-width: 1379px) {
  .inner {
    padding-left: var(--space-2-5x);
    padding-right: var(--space-2-5x);
  }
}

@media (max-width: 599px) {
  .content {
    padding-top: var(--space-2-5x);
    padding-bottom: var(--space-5x);
    gap: var(--space-2-5x);
  }
}
</style>
